"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// Components.
var LegalProvider_1 = require("./../../../services/LegalProvider");
var LegalDisclaimerPopup_1 = require("../../global/LegalDisclaimerPopup");
// Styles.
var LegalStyle = require("./Legal.css");
var Legal = /** @class */ (function (_super) {
    __extends(Legal, _super);
    function Legal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleModal = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({ showModal: true });
        };
        _this.handleCloseModal = function () {
            _this.setState({ showModal: false });
        };
        _this.getLegalContent = function (values) {
            if (values && values !== {}) {
                if (values.contentShort) {
                    return values.contentShort === "%{NULL}" ? null : values.contentShort;
                }
                else if (values.contentLong) {
                    return values.contentLong;
                }
            }
            return null;
        };
        _this.LegalContent = function (props) {
            if (_this.props.shortLegalString) { // use short legal string override if one is provided
                return React.createElement("span", null, _this.props.shortLegalString);
            }
            var state = _this.state;
            var legalContent = _this.getLegalContent(props.values);
            if (legalContent) {
                if (typeof legalContent === 'string') {
                    return React.createElement("div", { className: props.className, dangerouslySetInnerHTML: { __html: legalContent } });
                }
                else if (props.className) {
                    return React.createElement("span", { className: props.className }, legalContent);
                }
                return legalContent;
            }
            return null;
        };
        _this.LegalLink = function (props) {
            return props.link ? props.link : null;
        };
        _this.setLegalValues = function (legalPath, defaults, analytics) {
            if (!legalPath) {
                _this.setState({
                    legalPath: legalPath,
                    legalValues: undefined,
                });
            }
            else {
                _this.legalProvider.getLegal(legalPath, analytics, function (legalValues) {
                    _this.setState({
                        legalPath: legalPath,
                        legalValues: legalValues,
                    });
                }, defaults);
            }
        };
        var data = props.data || {};
        var options = props.options;
        // const breakpoint: number = options.breakpoint;
        _this.style = options.style || LegalStyle;
        _this.state = {
            className: [options.className, _this.style.legal].join(' '),
            contentClass: [options.contentClass, _this.style.legalContent].join(' '),
            legalPath: data.legalPath,
            legalValues: data.legalValues,
            showModal: false,
        };
        return _this;
    }
    Legal.prototype.componentDidMount = function () {
        var data = this.props.data || {};
        this.legalProvider = new LegalProvider_1.default();
        if (!this.state.legalValues && (this.state.legalPath || data.legalValues)) {
            this.setLegalValues(this.state.legalPath, data.legalValues, data.analytics);
        }
    };
    Legal.prototype.touchStartEvt = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    // This should be looked at and potentially updated to getDerivedStateFromProps in future versions.
    // UNSAFE_componentWillReceiveProps will go away in React version 17!!!
    Legal.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var nextData = nextProps.data || {};
        var nextOptions = nextProps.options;
        var breakpoint = nextOptions.breakpoint;
        var legalPath = nextData.legalPath;
        var className = [nextOptions.className, this.style.legal].join(' ');
        var contentClass = [nextOptions.contentClass, this.style.legalContent].join(' ');
        var newLegalValues = nextData.legalValues;
        if (nextProps.shortLegalString) {
            this.setState({
                legalValues: nextProps.data.legalValues,
            });
        }
        else if ((!legalPath && JSON.stringify(newLegalValues) !== JSON.stringify(this.state.legalValues)) ||
            (legalPath !== this.state.legalPath)) {
            this.setLegalValues(legalPath, newLegalValues, this.state.analytics);
        }
        if (className !== this.state.className) {
            this.setState({ className: className });
        }
        if (contentClass !== this.state.contentClass) {
            this.setState({ className: className });
        }
    };
    Legal.prototype.render = function () {
        var state = this.state;
        var props = this.props;
        if (state.legalValues && state.legalValues !== {}) {
            return (React.createElement("div", { className: state.className, id: this.props.options.id },
                React.createElement(this.LegalContent, { className: state.contentClass, values: state.legalValues }),
                React.createElement("span", { className: "font-medium " + this.style.highlight, onClick: this.handleModal, onTouchStart: this.touchStartEvt, tabIndex: 0 }, state.legalValues.shortDescLinkText),
                React.createElement(LegalDisclaimerPopup_1.default, { data: __assign(__assign({}, props.data.modalData), { close: this.handleCloseModal, content: state.showModal && props.data.modalData.content }) })));
        }
        return null;
    };
    return Legal;
}(React.PureComponent));
exports.default = Legal;
//# sourceMappingURL=Legal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Legal/Legal.js
// module id = 1175
// module chunks = 8